import React, {useEffect, useRef, useState} from "react";
import {useDispatch} from "react-redux";
import  "./timer.scss";
import { setStartTimeFinished} from "../../store/slices/examSlice";

const StartTimer = ({duration_start,id}) => {
    const dispatch = useDispatch();
    const [stop, setStop] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [countdown, setCountdown] = useState(() => {
        // const bk = JSON.parse(localStorage.getItem("meta"));
        return duration_start;
    });
    const tick = useRef(); // <-- React ref
    useEffect(() => {
        if (!stop) {
            tick.current = setInterval(() => { // <-- set tick ref current value
                setCountdown((timer) => {
                    if(0 === timer) {
                        stopTime(true);
                        return timer;
                    }
                    return timer - 1;
                });
            }, 1000);
        } else {
            stopTime();
        }

        return () => {
            clearInterval(tick.current)
        };
    }, [stop]);
    useEffect(() => {
        if(refresh) {
            dispatch(setStartTimeFinished({id}));
            // console.log("time finished called ",refresh);
            setRefresh(false);
        }
    }, [refresh]);
    const stopTime = (flag) => {
        clearInterval(tick.current);
        sendTimerCount(formatTimeToSend());
    }
    const sendTimerCount = (formatted) => {
       setRefresh(true);
    }
    const formatTimeToSend = () => {
        const hours = Math.floor(countdown / 3600);
        const minutes = Math.floor((countdown % 3600) / 60);
        const seconds = countdown % 60;
        return {
            hours,
            minutes,
            seconds
        }
    }
    const formatTime = (timeInSeconds) => {
        const hours = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor((timeInSeconds % 3600) / 60);
        const seconds = timeInSeconds % 60;

        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    };

    return (
        <div className="stimer">
            <span disabled={countdown > 0}> {formatTime(countdown)}</span>{" "}
        </div>
    )
}

export default StartTimer
